var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLinkMedium = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.5A1.5 1.5 0 005.5 7v10A1.5 1.5 0 007 18.5h10a1.5 1.5 0 001.5-1.5v-3a.5.5 0 011 0v3a2.5 2.5 0 01-2.5 2.5H7A2.5 2.5 0 014.5 17V7A2.5 2.5 0 017 4.5h3a.5.5 0 010 1H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5a.5.5 0 010-1h5a.499.499 0 01.5.497V10a.5.5 0 01-1 0V6.207l-5.146 5.147a.5.5 0 01-.708-.708L17.793 5.5H14z"
  })));
});
export default SvgExternalLinkMedium;